'use client';

import { useRouter } from 'next/navigation';
import { Button } from 'rizzui';
import type { ArticleCategory } from '@/app/shared/blog/types';

export function NewsFilters({
  categories,
  activeCategory,
  locale,
}: {
  categories: ArticleCategory[];
  activeCategory?: number;
  locale: string;
}) {
  const router = useRouter();

  const selectCategory = (category?: number) => {
    const path = `/${locale}/company/news`;
    router.push(category ? `${path}?category=${category}` : path);
  };

  return (
    <div className="filter-portfolio d-flex flex-xxl-column flex-md-row align-items-start flex-wrap gap-2 pb-4">
      <Button
        type="button"
        className={`at-btn filter-btn btn-sm ${!activeCategory ? 'active' : ''}`}
        onClick={() => selectCategory()}
      >
        All Insights
      </Button>
      {categories.map((category) => (
        <Button
          key={category.value}
          type="button"
          className={`at-btn filter-btn btn-sm ${activeCategory === category.value ? 'active' : ''}`}
          onClick={() => selectCategory(category.value)}
        >
          {category.label}
        </Button>
      ))}
    </div>
  );
}
